const paymentPurchaseTypes = [{ code: 'sale' }, { code: 'periodic' }];

export default paymentPurchaseTypes;
